// removed by extract-text-webpack-plugin
module.exports = {"content":"hHVtWSFjBXcF04iqXAKe8","title":"_3ALhszEUCu-OBXa36CFs9r","singleButtonDialog":"_1vP224gK_gxFL9MaVnhODp","dialogActionsRow":"_3PEy8Ko5s2x3lslEwcwGsE","btn":"_2JD3R9aR3H0ULx-eDrxzBH","errorDialog":"_2N_PCZkg3YydRo2yB-Hst1","primaryBtn":"_2nakgx9i-1oYdQBcDzwOpm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PortalDialog/PortalDialog.css
// module id = 1022
// module chunks = 0